import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Lightweight console breadcrumbs (Projects / …).
 * Matches Partner Console back-link conventions without a second nav system.
 */
export default function ProjectBreadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav className="mb-2" aria-label="Breadcrumb" data-testid="project-breadcrumbs">
      <ol className="breadcrumb mb-0 small">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={`${item.label}-${index}`}
              className={`breadcrumb-item${isLast ? ' active' : ''}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {!isLast && item.to ? <Link to={item.to}>{item.label}</Link> : item.label}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
